import React from "react";
import { BarChart3, FileText, Download, TrendingUp } from "lucide-react";

const SecretaryReports: React.FC = () => {
  return (
    <div className="p-6 min-h-screen bg-gradient-to-br from-gray-50 to-teal-50/30">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div>
              <h1 className="text-3xl font-bold text-gray-900">
                Reports & Analytics
              </h1>
              <p className="text-gray-600 mt-1">
                Generate reports on payments, students, and activities
              </p>
            </div>
            <button className="bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white px-6 py-3 rounded-xl flex items-center gap-2 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1 border-0">
              <FileText className="w-5 h-5" />
              Generate Report
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-2xl border-0 text-center">
          <BarChart3 className="w-16 h-16 text-teal-400 mx-auto mb-4" />
          <h2 className="text-xl font-bold text-gray-900 mb-2">
            Reports Dashboard
          </h2>
          <p className="text-gray-600 mb-6">
            Generate detailed reports on student registrations, fee payments,
            and other key metrics.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="p-6 bg-teal-50 rounded-xl">
              <FileText className="w-8 h-8 text-teal-600 mx-auto mb-3" />
              <h3 className="font-semibold text-gray-900 mb-2">
                Payment Reports
              </h3>
              <p className="text-sm text-gray-600">Fee collection summaries</p>
            </div>
            <div className="p-6 bg-blue-50 rounded-xl">
              <TrendingUp className="w-8 h-8 text-blue-600 mx-auto mb-3" />
              <h3 className="font-semibold text-gray-900 mb-2">
                Student Analytics
              </h3>
              <p className="text-sm text-gray-600">Registration trends</p>
            </div>
            <div className="p-6 bg-green-50 rounded-xl">
              <Download className="w-8 h-8 text-green-600 mx-auto mb-3" />
              <h3 className="font-semibold text-gray-900 mb-2">Export Data</h3>
              <p className="text-sm text-gray-600">PDF & Excel exports</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecretaryReports;
